import { useEffect, useState } from 'react';
import logoImg from '../assets/NAGARA_containerlogo.png';

function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`site-header ${isScrolled ? 'is-scrolled' : ''}`}>
      <div className="header-inner">
        <a href="/" className="brand-wrap" onClick={closeMenu}>
          <img
            src={logoImg}
            alt="NAGARA container"
            className="brand-mark"
          />
          <span className="brand">NAGARA container</span>
        </a>

        <nav className={`nav ${menuOpen ? 'is-open' : ''}`}>
          <a href="/#types" onClick={closeMenu}>コンテナタイプ</a>
          <a href="/#chassis" onClick={closeMenu}>シャーシ</a>
          <a href="/#yard" onClick={closeMenu}>ヤード</a>
          <a href="/#column" onClick={closeMenu}>コラム</a>
          <a href="/#company" onClick={closeMenu}>会社概要</a>
          <a href="/#contact" onClick={closeMenu}>お問い合わせ</a>
        </nav>
        <a
          href="https://www.instagram.com/nagaraworks.gujo/"
          className="insta-link"
          target="_blank"
          rel="noreferrer"
        >
          <i className="fa-brands fa-instagram"></i>
        </a>
        <button
          className={`menu-btn ${menuOpen ? 'is-open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニューを開く"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
}

export default Header;
